export const setSlotBookingRedirectPath = (state, action) => ({
  ...state,
  lastNonSlotBookingPath: action.url,
});
